import { SettingsPdf } from "./SettingsPdf";

export default SettingsPdf;

